import React, { useEffect } from 'react';
import { Box, Typography, Paper, useTheme, useMediaQuery, Link } from '@mui/material';
import OnboardingButton from '../../components/OnboardingButton';
import { showToast } from '../../utils/toastUtils';
import { useNavigate, Link as RouterLink, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setOnboardingComplete } from '../../redux/onboardingReducer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SettingsIcon from '@mui/icons-material/Settings';
import ChatIcon from '@mui/icons-material/Chat';

const OnboardingComplete = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paymentCompleted = useSelector((state) => state.onboarding.paymentCompleted);

  useEffect(() => {
    if (paymentCompleted) {
      dispatch(setOnboardingComplete());
      // Here you would typically also make an API call to update the server
      showToast('Onboarding completed successfully!', 'success');
    }
  }, [dispatch, paymentCompleted]);

  const handleContinueToDashboard = () => {
    navigate('/dashboard');
  };

  if (!paymentCompleted) {
    return <Navigate to="/onboarding/summary" />;
  }

  return (
    <Box sx={{ p: isMobile ? 2 : 4, maxWidth: 600, margin: 'auto' }}>
      <Paper elevation={3} sx={{ p: isMobile ? 3 : 4, borderRadius: 2, textAlign: 'center' }}>
        <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom fontWeight="bold" sx={{ mb: 3 }}>
          Onboarding Complete!
        </Typography>
        <Typography variant="body1" paragraph>
          Congratulations! You've successfully set up your AI Talker.
        </Typography>
        
        <Box sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
          <Typography variant="h5" gutterBottom fontWeight="bold">
            What's Next?
          </Typography>
          <Link component={RouterLink} to="/ai-talker/use-cases" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <SmartToyIcon sx={{ mr: 2, color: theme.palette.primary.main }} />
              <Typography variant="body1">
                Explore your new AI Talker capabilities
              </Typography>
            </Box>
          </Link>
          <Link component={RouterLink} to="/profile-settings" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <SettingsIcon sx={{ mr: 2, color: theme.palette.primary.main }} />
              <Typography variant="body1">
                Customize your settings in the dashboard
              </Typography>
            </Box>
          </Link>
          <Link component={RouterLink} to="/ai-talker/playground" sx={{ textDecoration: 'none', color: 'inherit' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <ChatIcon sx={{ mr: 2, color: theme.palette.primary.main }} />
              <Typography variant="body1">
                Start your first AI conversation
              </Typography>
            </Box>
          </Link>
        </Box>
        
        <Typography variant="body2" sx={{ mt: 2, mb: 3 }} color="text.secondary">
          You can always adjust your settings later.
        </Typography>
        
        <OnboardingButton 
          onClick={() => {
            handleContinueToDashboard();
            showToast('Welcome to your dashboard!', 'success');
          }}
        >
          Continue to Dashboard
        </OnboardingButton>
      </Paper>
    </Box>
  );
};

export default OnboardingComplete;
